module.exports = __webpack_public_path__ + "static/images/smartspot-performance.a6a06ab8acb2968bb5e5a118e270110b.png";